import { useEffect, useState, useCallback, useRef } from "react"
import SondaggiService from "../../../services/SondaggiService"
import { useLocation, } from 'react-router-dom';
import { Tabs, Tab, Container, Row, Col, Button } from "react-bootstrap";
import InformazioniSondaggio from "./InformazioniSondaggio";
import EsploraRisposteSondaggio from "./Risposte/EsploraRisposteSondaggio";
import { Navigate } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom';
import PartecipanteService from "../../../services/PartecipanteService";
import SondaggioPartecipanteService from "../../../services/SondaggioPartecipanteService";
/*

 <Route exact path="/sondaggio" element={
<PaginaSondaggio comune={comune} 
activeTab={activeTab} 
setActiveTab={setActiveTab} 
partecipante={partecipante} />} />
*/



export default function PaginaSondaggio(props){
    const [sondaggio, setSondaggio] = useState({})
    const [loadingSon, setLoadingSon] = useState(true)
    const [totalePartecipantiSondaggio, setTotalePartecipantiSondaggio] = useState(null)
    //const [partecipantiTotali, setPartecipantiTotali] = useState(null);
    const [loadingPartecipazione, setLoadingPartecipazione] = useState(true)

    const location = useLocation(); //hook di react-router-dom che da accesso all'oggetto location corrente, contiene informazion sull'url attuale (pathname, search, hash) e stato
    const navigate = useNavigate();

// Questo ref conterrà sempre l'ultimo ID del sondaggio,
    // permettendo alla callback stabile di leggerlo.
    const sondaggioIdRef = useRef(null);


    const cambiaTab = () => {
        props.setActiveTab(old => old === "informazioni" ? "risposte" : "informazioni")
    }

    // --- Effetto per aggiornare il Ref quando lo stato sondaggio cambia ---
    useEffect(() => {
        sondaggioIdRef.current = sondaggio?.sonId;
        // Questa dipendenza è corretta: aggiorna il ref solo se l'ID cambia.
    }, [sondaggio?.sonId]);


   // Definito con useCallback e dipendenze stabili
   const fetchSurveyData = useCallback(async (surveyId) => {
    if (!surveyId) {
        setLoadingSon(false);
        setLoadingPartecipazione(false);
        return;
    }
    console.log(`Fetching data for survey ID: ${surveyId}`);
    setLoadingSon(true);
    setLoadingPartecipazione(true);

    try {
        const resSondaggio = await SondaggiService.getSondaggioById(surveyId);
        const surveyData = resSondaggio.data;
        setSondaggio(surveyData);

        const resPartecipanti = await SondaggioPartecipanteService.getTotalePartecipantiSondaggio(surveyData.sonId);
        setTotalePartecipantiSondaggio(resPartecipanti.data);

    } catch (err) {
        console.error("Errore durante il fetch:", err);
        setSondaggio({});
        setTotalePartecipantiSondaggio(null);
    } finally {
        setLoadingSon(false);
        setLoadingPartecipazione(false);
    }
    // Assicurati che le dipendenze qui siano stabili (es. solo setState)
}, []);

const handleTimerExpire = useCallback(() => {
    console.log("Timer scaduto sul parent, provo a rieseguire il fetch.");

    // Leggi l'ID più recente dal Ref invece che dallo stato
    const currentSurveyId = sondaggioIdRef.current;

    if (currentSurveyId) {
        console.log(`Eseguo fetch per ID dal Ref: ${currentSurveyId}`);
        fetchSurveyData(currentSurveyId); // Chiama la funzione di fetch stabile
    } else {
        console.warn("handleTimerExpire chiamato ma sondaggioIdRef.current è null.");
    }

// --- Dipendenze di useCallback ---
// Ora dipende SOLO da fetchSurveyData (che deve essere stabile).
// Non dipende più dallo stato 'sondaggio'.
}, [fetchSurveyData]); // <--- Rimosso sondaggio?.sonId

    //fetch sondaggio
    // Ora usa fetchSurveyData
    useEffect(() => {
        const surveyIdFromState = location.state?.sonId;

        if (surveyIdFromState) {
            fetchSurveyData(surveyIdFromState); // Chiama la funzione riutilizzabile

            // Imposta activeTab se presente nello stato della location
            if (location.state.activeTab === "risposte") {
                props.setActiveTab("risposte");
            } else if (location.state.activeTab === "info") { // Usa else if
                props.setActiveTab("informazioni");
            }
        } else {
            // Se non c'è ID nella location state, non caricare nulla e magari naviga via
            console.warn("Nessun sonId trovato in location.state");
            setLoadingSon(false); // Assicurati che il loading finisca
            setLoadingPartecipazione(false);
            // Potresti voler reindirizzare qui se l'ID è obbligatorio
            // navigate('/pagina-non-trovata', { replace: true });
        }
        // Le dipendenze includono l'ID dalla location e la funzione di fetch
        // Non includere l'intero location.state se cambi solo activeTab senza cambiare ID
    }, [location.state?.sonId, location.state?.activeTab, fetchSurveyData, props.setActiveTab]);

    if (props.comune && props.comune.impostazioniComune) {
        if (
            props.comune.impostazioniComune.imcModuloSondaggiAttivo &&
            location.state &&
            location.state.sonId
        ) {
            return (
                <>
                    <div className="bg-secondary w-100" style={{ minHeight: "30vh", position: "absolute", zIndex: "-1" }} />
                    <Container className="mt-4 mb-4">
                        <span className="smallcaps dark">{props.comune.impostazioniComune.imcLabelModuloSondaggi}</span>
                        <h1 className="title dark">{sondaggio.sonTitolo}</h1>
                    </Container>
                    <Container >
                        <Tabs activeKey={props.activeTab} className="bg-light" style={{ borderRadius: "10px 10px 0px 0px" }}
                            onClick={cambiaTab}>
                            <Tab eventKey="informazioni" title="Informazioni">
                                <InformazioniSondaggio
                                    sondaggio={sondaggio}
                                    activeTab={props.activeTab}
                                    cambiaTab={cambiaTab}
                                    partecipante={props.partecipante}
                                    loadingSon={loadingSon}
                                    onTimeExpire={handleTimerExpire} // <-- Passa la callback qui!

                                    //partecipantiTotali={partecipantiTotali}
                                    totalePartecipantiSondaggio={totalePartecipantiSondaggio}
                                    loadingPartecipazione={loadingPartecipazione}

                                />
                            </Tab>
                            <Tab eventKey="risposte" title="Vedi le risposte">
                                <EsploraRisposteSondaggio
                                    sondaggio={sondaggio}
                                    comune={props.comune}
                                    partecipante={props.partecipante}
                                    loadingSon={loadingSon}
                                />
                            </Tab>
                        </Tabs>
                        <Row className="mb-2 align-items-center">
                            <Col xs={6} md={6} lg={6} className='pr-0 mt-2'>
                                <Button variant="outline-dark "
                                    onClick={() => {
                                        navigate(-1)
                                    }}>
                                    <FiChevronLeft />
                                    Torna a tutti gli elementi
                                </Button>
                            </Col>
                            <Col xs={6} md={6} lg={6} className="p-0 mr-0">
                                {props.activeTab === "informazioni" &&
                                    <Button variant="outline-dark "
                                        onClick={() => {
                                            cambiaTab()
                                        }}>
                                        Vedi le risposte
                                        <FiChevronRight />
                                    </Button>}
                            </Col>
                            
                        </Row>
                    </Container>
                </>
            )
        } else {
            return (
                <>
                    <Navigate replace to="/pagina-non-trovata" />
                </>
            )
        }
    }
}